import { ExpenseAction, IExpense } from 'models';
import { Api } from './api';
import { GetAllFactory, CreateFactory, UpdateFactory, DeleteFactory, GetFactory } from './base.service';
import CrudService from './crud.service';
import { BaseGetAllParams } from './defaults';

const BASE_URL = 'expenses';
const SERVICE_NAME = 'Expense';

class ExpenseService<T> extends CrudService<T> {
  public async GetAttachments(id: any) {
    const result = await Api.get<Partial<T>, T>(`/expenses/${id}/attachments`);
    return result;
  }
}

export interface GetAllParams extends BaseGetAllParams {
  contact?: string;
  action?: ExpenseAction;
}

// Delete this soon
export default new ExpenseService<IExpense>(SERVICE_NAME, BASE_URL);

export const GetAll = GetAllFactory<IExpense, GetAllParams>(BASE_URL);
export const Get = GetFactory<IExpense>(BASE_URL);
export const Create = CreateFactory<IExpense>(BASE_URL, SERVICE_NAME);
export const Update = UpdateFactory<IExpense>(BASE_URL, SERVICE_NAME);
export const Delete = DeleteFactory(BASE_URL, SERVICE_NAME);
